<div class="mb-3">
  <form [formGroup]="networkEventForm" class="tablelist-form" autocomplete="off">
    <div class="row">
      <div class="col-6">
        <div class="mb-3">
          <strong>General Details</strong>
        </div>
        <div class="border border-success rounded px-2">
          <label id="spacer" class="form-label"></label>
          <!--
          @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.id != undefined)) {
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="id-field" class="form-label">ID</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="id-field" class="form-label">{{formOfNetworkEvent['id'].value}}</label>
                </div>
              </div>
            </div>
          }
          -->                                                                
          <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.Type != undefined && networkEvent.Type != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="Type-field" class="form-label">Type</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="Type-field" class="form-label">{{formOfNetworkEvent['Type'].value}}</label>
                </div>
              </div>
            </div>
          <!-- } -->
                                                                
          <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.EventDate != undefined && networkEvent.EventDate != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="EventDate-field" class="form-label">Event Date</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="EventDate-field" class="form-label">{{formOfNetworkEvent['EventDate'].value}}</label>
                </div>
              </div>
            </div>
          <!-- } -->
                                                                
          <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.Status != undefined && networkEvent.Status != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="Status-field" class="form-label">Status</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="Status-field" class="form-label">{{formOfNetworkEvent['Status'].value}}</label>
                </div>
              </div>
            </div>
          <!-- } -->
                                                                
          <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.SubStatus != undefined && networkEvent.SubStatus != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="SubStatus-field" class="form-label">Sub Status</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="SubStatus-field" class="form-label">{{formOfNetworkEvent['SubStatus'].value}}</label>
                </div>
              </div>
            </div>
          <!-- } -->
                                                                
          <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.Source != undefined && networkEvent.Source != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="Source-field" class="form-label">Source</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="Source-field" class="form-label">{{formOfNetworkEvent['Source'].value}}</label>
                </div>
              </div>
            </div>
          <!-- } -->
                                                                
          <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.IMSI != undefined && networkEvent.IMSI != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="IMSI-field" class="form-label">IMSI</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="IMSI-field" class="form-label">{{formOfNetworkEvent['IMSI'].value}}</label>
                </div>
              </div>
            </div>
          <!-- } -->
                                                                
          <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.ICCID != undefined && networkEvent.ICCID != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="ICCID-field" class="form-label">ICCID</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="ICCID-field" class="form-label">{{formOfNetworkEvent['ICCID'].value}}</label>
                </div>
              </div>
            </div>
          <!-- } -->
                                                                
          <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.MSISDN != undefined && networkEvent.MSISDN != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="MSISDN-field" class="form-label">MSISDN</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="MSISDN-field" class="form-label">{{formOfNetworkEvent['MSISDN'].value}}</label>
                </div>
              </div>
            </div>
          <!-- } -->

          <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.IMEI != undefined && networkEvent.IMEI != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="IMEI-field" class="form-label">IMEI</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="IMEI-field" class="form-label">{{formOfNetworkEvent['IMEI'].value}}</label>
                </div>
              </div>
            </div>
          <!-- } -->
                                                                
          <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.DeviceVendor != undefined && networkEvent.DeviceVendor != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="DeviceVendor-field" class="form-label">Device Vendor</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="DeviceVendor-field" class="form-label">{{formOfNetworkEvent['DeviceVendor'].value}}</label>
                </div>
              </div>
            </div>
          <!-- } -->
                                                                
          <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.DeviceModel != undefined && networkEvent.DeviceModel != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="DeviceModel-field" class="form-label">Device Model</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="DeviceModel-field" class="form-label">{{formOfNetworkEvent['DeviceModel'].value}}</label>
                </div>
              </div>
            </div>
          <!-- } -->
                                                                
          <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.SD != undefined && networkEvent.SD != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="SD-field" class="form-label">SD</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="SD-field" class="form-label">{{formOfNetworkEvent['SD'].value}}</label>
                </div>
              </div>
            </div>
          <!-- } -->
          <!--                                                      
          @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.Product != undefined && networkEvent.Product != "")) {
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="Product-field" class="form-label">Product</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="Product-field" class="form-label">{{formOfNetworkEvent['Product'].value}}</label>
                </div>
              </div>
            </div>
          }
          -->                                                      
          <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.APN != undefined && networkEvent.APN != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="APN-field" class="form-label">APN</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="APN-field" class="form-label">{{formOfNetworkEvent['APN'].value}}</label>
                </div>
              </div>
            </div>
          <!-- } -->
                                                                
          <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.APNOverride != undefined && networkEvent.APNOverride != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="APNOverride-field" class="form-label">APN Override</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="APNOverride-field" class="form-label">{{formOfNetworkEvent['APNOverride'].value}}</label>
                </div>
              </div>
            </div>
          <!-- } -->
                                                                
          <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.SubscriberIP != undefined && networkEvent.SubscriberIP != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="SubscriberIP-field" class="form-label">Subscriber IP</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="SubscriberIP-field" class="form-label">{{formOfNetworkEvent['SubscriberIP'].value}}</label>
                </div>
              </div>
            </div>
          <!-- } -->
                                                                
          <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.AssignedIP != undefined && networkEvent.AssignedIP != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="AssignedIP-field" class="form-label">Assigned IP</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="AssignedIP-field" class="form-label">{{formOfNetworkEvent['AssignedIP'].value}}</label>
                </div>
              </div>
            </div>
          <!-- } -->
                                                                
          <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.MCCMNC != undefined && networkEvent.MCCMNC != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="MCCMNC-field" class="form-label">MCCMNC</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="MCCMNC-field" class="form-label">{{formOfNetworkEvent['MCCMNC'].value}}</label>
                </div>
              </div>
            </div>
          <!-- } -->
                                                                
          <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.VPLMN != undefined && networkEvent.VPLMN != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="VPLMN-field" class="form-label">VPLMN</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="VPLMN-field" class="form-label">{{formOfNetworkEvent['VPLMN'].value}}</label>
                </div>
              </div>
            </div>
          <!-- } -->
                                                                
          <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.RatType != undefined && networkEvent.RatType != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="RatType-field" class="form-label">Rat Type</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="RatType-field" class="form-label">{{formOfNetworkEvent['RatType'].value}}</label>
                </div>
              </div>
            </div>
          <!-- } -->
                                                                
          <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.NetworkGeneration != undefined && networkEvent.NetworkGeneration != "")) { -->
            <!-- <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="NetworkGeneration-field" class="form-label">Network Generation</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="NetworkGeneration-field" class="form-label">{{formOfNetworkEvent['NetworkGeneration'].value}}</label>
                </div>
              </div>
            </div> -->
          <!-- } -->
                                                                
          <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.Country != undefined && networkEvent.Country != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="Country-field" class="form-label">Country</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="Country-field" class="form-label">
                    <img
                    width="16"
                    [src]="formOfNetworkEvent['CountryFlag'].value"/>
                    <span> {{formOfNetworkEvent['Country'].value}}</span>
                    </label>
                </div>
              </div>
            </div>
          <!-- } -->

          <!--RBW_20260610 - Cell Tower ID and Loc. Area Code ID moved out of General Details into the Location Awareness Details section below-->
        </div>
      </div>

      <div class="col-6">
      @if((networkEvent != undefined && networkEvent.Type != undefined && (networkEvent.Type == "Accounting Stop" || networkEvent.Type == "Accounting Interim"))) {
        <div>
          <div class="mb-3">
            <strong>{{networkEvent.Type}} Details</strong>
          </div>
          <div class="border border-success rounded px-2">
            <label id="spacer" class="form-label"></label>

            <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.Uplink != undefined && networkEvent.Uplink != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="Uplink-field" class="form-label">Uplink</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="Uplink-field" class="form-label">{{formOfNetworkEvent['Uplink'].value}}</label>
                </div>
              </div>
            </div>
            <!-- } -->
                                                                  
            <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.Downlink != undefined && networkEvent.Downlink != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="Downlink-field" class="form-label">Downlink</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="Downlink-field" class="form-label">{{formOfNetworkEvent['Downlink'].value}}</label>
                </div>
              </div>
            </div>
            <!-- } -->
                                                                  
            <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.InputPackets != undefined && networkEvent.InputPackets != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="InputPackets-field" class="form-label">Input Packets</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="InputPackets-field" class="form-label">{{formOfNetworkEvent['InputPackets'].value}}</label>
                </div>
              </div>
            </div>
            <!-- } -->
                                                                  
            <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.OutputPackets != undefined && networkEvent.OutputPackets != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="OutputPackets-field" class="form-label">Output Packets</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="OutputPackets-field" class="form-label">{{formOfNetworkEvent['OutputPackets'].value}}</label>
                </div>
              </div>
            </div>
            <!-- } -->
                                                                  
            <!-- @if(!gridHasBeenClicked || (networkEvent != undefined && networkEvent.SessionTime != undefined && networkEvent.SessionTime != "")) { -->
            <div class="row">
              <div class="col-3">
                <div class="mb-0">
                 <label for="SessionTime-field" class="form-label">Session Time</label>
                </div>
              </div>
              <div class="col-9">
                <div class="mb-0">
                  <label id="SessionTime-field" class="form-label">{{formOfNetworkEvent['SessionTime'].value}}</label>
                </div>
              </div>
            </div>
            <!-- } -->
          </div>
        </div>
      }

      <!--RBW_20260611 - Location Awareness Details: always visible. Shows a license/disabled/not-available message as appropriate, otherwise the resolved cell tower location.-->
      @if(networkEvent != undefined) {
        <div [class.mt-3]="networkEvent.Type == 'Accounting Stop' || networkEvent.Type == 'Accounting Interim'">
          <div class="mb-3">
            <strong>Location Awareness Details</strong>
          </div>
          <div class="border border-success rounded px-2">
            <label id="spacer" class="form-label"></label>

            @if(!locationLicensed) {
              <div class="row">
                <div class="col-12">
                  <div class="mb-0">
                    <label class="form-label text-danger">Location awareness license required.</label>
                  </div>
                </div>
              </div>
            } @else if(!networkEvent.LocationServicesEnabled) {
              <div class="row">
                <div class="col-12">
                  <div class="mb-0">
                    <label class="form-label text-danger">Location awareness disabled for this SIM.</label>
                  </div>
                </div>
              </div>
            } @else if(networkEvent.Location != undefined && networkEvent.Location.HomeGuard) {
              <div class="row">
                <div class="col-12">
                  <div class="mb-0">
                    <label class="form-label text-primary">Home guard active, no location details available for users home country.</label>
                  </div>
                </div>
              </div>
            } @else if((networkEvent.CellID == undefined || networkEvent.CellID == "") && (networkEvent.LACID == undefined || networkEvent.LACID == "")) {
              <div class="row">
                <div class="col-12">
                  <div class="mb-0">
                    @if(networkEvent.Type == "Location Update") {
                      <label class="form-label">Cell tower location not available for this event type.</label>
                    } @else {
                      <label class="form-label">Location not available.</label>
                    }
                  </div>
                </div>
              </div>
            } @else {
              <div class="row">
                <div class="col-3">
                  <div class="mb-0">
                   <label for="LocationCellID-field" class="form-label">Cell Tower ID</label>
                  </div>
                </div>
                <div class="col-9">
                  <div class="mb-0">
                    <label id="LocationCellID-field" class="form-label">{{networkEvent.CellID}}</label>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-3">
                  <div class="mb-0">
                   <label for="LocationLACID-field" class="form-label">Loc. Area Code ID</label>
                  </div>
                </div>
                <div class="col-9">
                  <div class="mb-0">
                    <label id="LocationLACID-field" class="form-label">{{networkEvent.LACID}}</label>
                  </div>
                </div>
              </div>

              @if(networkEvent.Location != undefined) {
                @if(networkEvent.Location.PlaceName != undefined && networkEvent.Location.PlaceName != "") {
                  <div class="row">
                    <div class="col-3">
                      <div class="mb-0">
                       <label for="LocationPlace-field" class="form-label">Place Name</label>
                      </div>
                    </div>
                    <div class="col-9">
                      <div class="mb-0">
                        <label id="LocationPlace-field" class="form-label">{{networkEvent.Location.PlaceName}}</label>
                      </div>
                    </div>
                  </div>
                }

                @if(networkEvent.Location.State != undefined && networkEvent.Location.State != "") {
                  <div class="row">
                    <div class="col-3">
                      <div class="mb-0">
                       <label for="LocationState-field" class="form-label">Region</label>
                      </div>
                    </div>
                    <div class="col-9">
                      <div class="mb-0">
                        <label id="LocationState-field" class="form-label">{{networkEvent.Location.State}}</label>
                      </div>
                    </div>
                  </div>
                }

                @if(networkEvent.Country != undefined && networkEvent.Country != "") {
                  <div class="row">
                    <div class="col-3">
                      <div class="mb-0">
                       <label for="LocationCountry-field" class="form-label">Country</label>
                      </div>
                    </div>
                    <div class="col-9">
                      <div class="mb-0">
                        <label id="LocationCountry-field" class="form-label">
                          <img
                          width="16"
                          [src]="networkEvent.CountryFlag"/>
                          <span> {{networkEvent.Country}}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                }
              } @else {
                <div class="row">
                  <div class="col-12">
                    <div class="mb-0">
                      <label class="form-label">Location Unknown</label>
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        </div>
      }
      </div>
    </div>
  </form>
</div>
